import { render, staticRenderFns } from "./ServiceStartStep.vue?vue&type=template&id=6a236580&"
import script from "./ServiceStartStep.vue?vue&type=script&lang=js&"
export * from "./ServiceStartStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports